var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spin',{staticClass:"loading",style:({
        visibility:
            _vm.visible || !_vm.delayComplete ? 'visible' : 'hidden'
    }),attrs:{"fix":""}},[_c('span',{class:[
            'ant-spin-dot',
            'ant-spin-dot-spin',
            _vm.size === 'large' && 'ant-spin-lg'
        ]},[_c('i',{staticClass:"ant-spin-dot-item"}),_c('i',{staticClass:"ant-spin-dot-item"}),_c('i',{staticClass:"ant-spin-dot-item"}),_c('i',{staticClass:"ant-spin-dot-item"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/extends/loading.vue